
















import axios from 'axios';
import token from './AccessToke';
import Navigation from './views/Navigation.vue';
import moment from 'moment';


import {Vue,  Component } from 'vue-property-decorator';

axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem('accessToken');

@Component({
    components: {Navigation}, 
})
export default class App extends Vue {

 
    created(){
        axios.defaults.headers.common["Authorization"] = "Bearer " + this.$store.state.auth.accessToken
    }

    get thisYear(): number {
        return moment().year();
    }



}
